import { render, staticRenderFns } from "./A4Horizontal.vue?vue&type=template&id=7caf1144&scoped=true"
import script from "./A4Horizontal.vue?vue&type=script&lang=js"
export * from "./A4Horizontal.vue?vue&type=script&lang=js"
import style0 from "./A4Horizontal.vue?vue&type=style&index=0&id=7caf1144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf1144",
  null
  
)

export default component.exports